var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubtSupportButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "white",
    stroke: "#EFEFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9417_7858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 36.5625C24.9844 36.5625 27.6719 33.875 27.6719 30.5781C27.6719 27.2812 24.9844 24.5937 21.6875 24.5937C18.3906 24.5937 15.7031 27.2812 15.7031 30.5781C15.7031 33.875 18.3906 36.5625 21.6875 36.5625ZM21.6875 26.7969C23.7734 26.7969 25.4688 28.4922 25.4688 30.5781C25.4688 32.6641 23.7734 34.3594 21.6875 34.3594C19.6016 34.3594 17.9062 32.6641 17.9062 30.5781C17.9141 28.4922 19.6094 26.7969 21.6875 26.7969ZM25.0859 38.3516C24.6797 38.3516 24.3125 38.5703 24.1172 38.9297L21.6875 43.3984L19.2656 38.9297C19.0703 38.5781 18.7031 38.3516 18.2969 38.3516C14.9062 38.3516 12.1562 41.1094 12.1562 44.4922V49.7422C12.1562 50.3516 12.6484 50.8437 13.2578 50.8437H30.125C30.7344 50.8437 31.2266 50.3516 31.2266 49.7422V44.4922C31.2266 41.1094 28.4688 38.3516 25.0859 38.3516ZM29.0234 48.6406H14.3594V44.4922C14.3594 42.5391 15.7891 40.9141 17.6641 40.6094L20.7188 46.2422C21.1484 46.9453 22.1797 47.0703 22.6562 46.2422L25.7109 40.6094C27.5859 40.9141 29.0156 42.5391 29.0156 44.4922V48.6406H29.0234ZM37.375 16.6719C37.1328 17.2266 37.3828 17.8828 37.9375 18.125C38.4922 18.3672 39.1484 18.1172 39.3906 17.5625C39.8828 16.5859 41.1172 16.8437 41.3594 17.7266C41.4922 18.3047 41.1641 18.7266 40.8047 18.9219C39.1719 19.8047 39.25 21.7578 39.25 21.7578C39.25 22.3672 39.7422 22.8594 40.3516 22.8594C40.9609 22.8594 41.4531 22.3672 41.4531 21.7578C41.4531 21.7578 41.3828 21.1094 41.7734 20.8984C43.1172 20.1953 43.8516 18.7266 43.5078 17.2266C42.7891 14.2891 38.8281 13.7187 37.375 16.6719ZM40.3438 23.8203C39.7344 23.8203 39.2422 24.3125 39.2422 24.9219V25.6641C39.2422 26.2734 39.7344 26.7656 40.3438 26.7656C40.9531 26.7656 41.4453 26.2734 41.4453 25.6641V24.9219C41.4453 24.3125 40.9531 23.8203 40.3438 23.8203Z",
    fill: "url(#paint0_linear_9417_7858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4297 11.1562C34.1406 11.1562 29.0156 15.4609 29.0156 20.7578C29.0156 23.2266 30.1016 25.5312 32.0938 27.3125L31.3672 32.5C31.2266 33.3438 32.1094 34.1328 33.0391 33.5938L38.5 30.2188C39.1406 30.3125 39.7891 30.3594 40.4297 30.3594C46.7188 30.3594 51.8438 26.0547 51.8438 20.7578C51.8438 15.4609 46.7266 11.1562 40.4297 11.1562ZM40.4297 28.1484C39.7734 28.1484 39.1016 28.1406 38.4609 27.9766C37.7734 27.8047 33.8828 30.4844 33.8828 30.4844L34.3672 27.0156C34.4219 26.6328 34.2656 26.2422 33.9609 26C32.1953 24.5938 31.2266 22.7344 31.2266 20.75C31.2266 16.6719 35.3594 13.3516 40.4297 13.3516C45.5 13.3516 49.6328 16.6719 49.6328 20.75C49.6406 24.8359 45.5078 28.1484 40.4297 28.1484Z",
    fill: "url(#paint1_linear_9417_7858)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9417_7858",
    x1: 27.8741,
    y1: 14.7202,
    x2: 27.8741,
    y2: 50.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F85BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9417_7858",
    x1: 40.4297,
    y1: 11.1562,
    x2: 40.4297,
    y2: 33.7704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F85BA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9417_7858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubtSupportButton);
export default __webpack_public_path__ + "static/media/doubt-support-button.f83a94a6da3f8a37e12317cc7ac22e2a.svg";
export { ForwardRef as ReactComponent };